// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type DeleteEpmMasterRoleTypeMutationVariables = Types.Exact<{
  deleteEpmMasterRoleTypeId: Types.Scalars['ID']['input'];
}>;

export type DeleteEpmMasterRoleTypeMutation = { __typename?: 'Mutation' } & Pick<
  Types.Mutation,
  'deleteEpmMasterRoleType'
>;

export const DeleteEpmMasterRoleTypeDocument = /*#__PURE__*/ gql`
    mutation DeleteEpmMasterRoleType($deleteEpmMasterRoleTypeId: ID!) {
  deleteEpmMasterRoleType(id: $deleteEpmMasterRoleTypeId)
}
    `;
export type DeleteEpmMasterRoleTypeMutationFn = Apollo.MutationFunction<
  DeleteEpmMasterRoleTypeMutation,
  DeleteEpmMasterRoleTypeMutationVariables
>;

/**
 * __useDeleteEpmMasterRoleTypeMutation__
 *
 * To run a mutation, you first call `useDeleteEpmMasterRoleTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEpmMasterRoleTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEpmMasterRoleTypeMutation, { data, loading, error }] = useDeleteEpmMasterRoleTypeMutation({
 *   variables: {
 *      deleteEpmMasterRoleTypeId: // value for 'deleteEpmMasterRoleTypeId'
 *   },
 * });
 */
export function useDeleteEpmMasterRoleTypeMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteEpmMasterRoleTypeMutation, DeleteEpmMasterRoleTypeMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteEpmMasterRoleTypeMutation, DeleteEpmMasterRoleTypeMutationVariables>(
    DeleteEpmMasterRoleTypeDocument,
    options,
  );
}
export type DeleteEpmMasterRoleTypeMutationHookResult = ReturnType<typeof useDeleteEpmMasterRoleTypeMutation>;
export type DeleteEpmMasterRoleTypeMutationOptions = Apollo.BaseMutationOptions<
  DeleteEpmMasterRoleTypeMutation,
  DeleteEpmMasterRoleTypeMutationVariables
>;
